module.exports = __webpack_public_path__ + "static/media/img-scope5.bcce26c8.png";